export type IModifyUrlParam = (
  url: string,
  paramName: string,
  newValue: string,
  remove?: boolean
) => string;

export function modifyUrlParam(
  url: string,
  paramName: string,
  newValue: string,
  remove?: boolean
): string {
  let b = '';
  let name;
  let value;
  let str;

  const urlParams = window.DexeroCoreApp.paraseURL(url);
  const paramsExist = Object.keys(urlParams).length > 2;
  const valueExists = !!Object.hasOwnProperty.call(urlParams, paramName);

  if (!paramsExist) {
    console.warn('Error: URL passed, does not have any URL parameters.');
    return url;
  }

  for (const index in urlParams) {
    if (!Object.hasOwnProperty.call(urlParams, index)) {
      continue;
    }
    name = index;
    value = urlParams[index];
    str = `${index}=${value}`;

    if (name !== 'urlBase' && name !== 'urlParamString') {
      if (name === paramName && remove) {
        continue;
      } else if (name === paramName && !remove) {
        str = `${name}=${newValue}`;
      }

      if (b !== '') {
        b += '&';
      }
      b += str;
    }
  }
  // If the value did not exist in the params, and we are not looking to remove it, add it
  if (!valueExists && !remove) {
    b += `&${paramName}=${newValue}`;
  }
  return `${urlParams.urlBase}?${b}`;
}
